import { createAction } from 'redux-actions';

export const SET_POLITE_STATUS_MESSAGE = 'SET_POLITE_MESSAGE';
export const SET_ASSERTIVE_STATUS_MESSAGE = 'SET_ASSERTIVE_STATUS_MESSAGE';

export const setPoliteStatusMessage = createAction(SET_POLITE_STATUS_MESSAGE);
export const setAssertiveStatusMessage = createAction(SET_ASSERTIVE_STATUS_MESSAGE);
